import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// --- Узбекский (uz) ---
import uzCommon from './locales/uz/common.json';
import uzNavigation from './locales/uz/navigation.json';
import uzAuth from './locales/uz/auth.json';
import uzReports from './locales/uz/reports.json';
import uzDocuments from './locales/uz/documents.json';
import uzPlans from './locales/uz/plans.json';
import uzAnalytics from './locales/uz/analytics.json';
import uzAi from './locales/uz/ai.json';
import uzAdmin from './locales/uz/admin.json';
import uzNotifications from './locales/uz/notifications.json';
import uzPresentations from './locales/uz/presentations.json';
import uzConstructor from './locales/uz/constructor.json';
import uzWeeklyControl from './locales/uz/weeklyControl.json';
import uzProfile from './locales/uz/profile.json';
import uzKpi from './locales/uz/kpi.json';

// --- Русский (ru) ---
import ruCommon from './locales/ru/common.json';
import ruNavigation from './locales/ru/navigation.json';
import ruAuth from './locales/ru/auth.json';
import ruReports from './locales/ru/reports.json';
import ruDocuments from './locales/ru/documents.json';
import ruPlans from './locales/ru/plans.json';
import ruAnalytics from './locales/ru/analytics.json';
import ruAi from './locales/ru/ai.json';
import ruAdmin from './locales/ru/admin.json';
import ruNotifications from './locales/ru/notifications.json';
import ruPresentations from './locales/ru/presentations.json';
import ruConstructor from './locales/ru/constructor.json';
import ruWeeklyControl from './locales/ru/weeklyControl.json';
import ruProfile from './locales/ru/profile.json';
import ruKpi from './locales/ru/kpi.json';

const NAMESPACES = [
  'common', 'navigation', 'auth', 'reports', 'documents', 'plans',
  'analytics', 'ai', 'admin', 'notifications', 'presentations',
  'constructor', 'weeklyControl', 'profile', 'kpi',
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      uz: {
        common: uzCommon,
        navigation: uzNavigation,
        auth: uzAuth,
        reports: uzReports,
        documents: uzDocuments,
        plans: uzPlans,
        analytics: uzAnalytics,
        ai: uzAi,
        admin: uzAdmin,
        notifications: uzNotifications,
        presentations: uzPresentations,
        constructor: uzConstructor,
        weeklyControl: uzWeeklyControl,
        profile: uzProfile,
        kpi: uzKpi,
      },
      ru: {
        common: ruCommon,
        navigation: ruNavigation,
        auth: ruAuth,
        reports: ruReports,
        documents: ruDocuments,
        plans: ruPlans,
        analytics: ruAnalytics,
        ai: ruAi,
        admin: ruAdmin,
        notifications: ruNotifications,
        presentations: ruPresentations,
        constructor: ruConstructor,
        weeklyControl: ruWeeklyControl,
        profile: ruProfile,
        kpi: ruKpi,
      },
    },
    lng: localStorage.getItem('language') || 'uz',
    fallbackLng: 'ru',
    defaultNS: 'common',
    ns: NAMESPACES,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'language',
      caches: ['localStorage'],
    },
  });

export default i18n;
